import React, { useEffect, useState } from "react";
import { EditorData, Picking } from "../../../utils/editorUtils";
import { FormattedMessage } from "react-intl";
import { ReactComponent as AddIcon } from "./../../../images/editor-icons/plus.svg";
import { useEditState } from "../EditContext";
import Tooltip from "../BaseComponents/Tooltip";
import { StyledNavigationMobile } from "../../Navigation/NavigationMobileStyles";
import ActionList from "../../../shared/components/ActionList";
import Action from "../../../shared/components/Action";

interface MapAddButtonsProps {
  setPicking: React.Dispatch<React.SetStateAction<Picking>>;
}

const MapAddButtons: React.FC<MapAddButtonsProps> = ({ setPicking }) => {
  const { data } = useEditState();
  const [editorData, setEditorData] = useState<EditorData<"map">>(data as EditorData<"map">);
  useEffect(() => {
    setEditorData(data as EditorData<"map">);
  }, [data]);

  const panoDisabled = !(
    editorData.unused_panorama_location && editorData.unused_panorama_location.length > 0
  );
  const poiDisabled = !(
    editorData.unused_poi_location && editorData.unused_poi_location.length > 0
  );

  return (
    <StyledNavigationMobile>
      <ActionList>
        <Tooltip
          message={
            <FormattedMessage
              id="editor.map.link.add_link.no_pano_locations"
              defaultMessage="All available panoramas have already been placed."
              description="Tooltip for disabled panorama button when no panoramas are available"
            />
          }
          disabled={!panoDisabled}
        >
          <Action
            icon={<AddIcon />}
            onClick={() => panoDisabled || setPicking(Picking.Pano)}
            disabled={panoDisabled}
          >
            <FormattedMessage
              id="editor.map.link.add_pano"
              defaultMessage="Add panorama"
              description="Text for add panorama link button"
            />
          </Action>
        </Tooltip>
        <Tooltip
          message={
            <FormattedMessage
              id="editor.map.link.add_link.no_poi_locations"
              defaultMessage="All available pois have already been placed."
              description="Tooltip for disabled POI button when no pois are available"
            />
          }
          disabled={!poiDisabled}
        >
          <Action
            icon={<AddIcon />}
            onClick={() => poiDisabled || setPicking(Picking.Poi)}
            disabled={poiDisabled}
          >
            <FormattedMessage
              id="editor.map.link.add_poi"
              defaultMessage="Add POI"
              description="Text for add poi link button"
            />
          </Action>
        </Tooltip>
      </ActionList>
    </StyledNavigationMobile>
  );
};

export default MapAddButtons;
